var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"icon-img",class:[{'mu-p': _vm.cursorPointer},
     {'icon-img-h-scale-up': _vm.hoverEffect==='basic-1'},{'icon-img-h-rotate': _vm.hoverEffect ==='basic-2'},
       {'icon-img-rotate': _vm.rotate !==''}, _vm.classNames, _vm.additionalClasses,],style:([{height: _vm.heightValue}, _vm.setHoverRotateValue,
     _vm.setHoverScaleValue, _vm.setTransitionDurationValue, _vm.sethoverOpacity, _vm.setRotation]),attrs:{"src":_vm.image,"alt":""},on:{"click":function($event){return _vm.$emit('click')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }